/**
 * The instalment plan a shopper picked in the basket, carried across to the
 * checkout page.
 *
 * Session storage rather than a provider: the choice belongs to this one trip
 * to the checkout and should not outlive the tab. Only the ids are kept — the
 * checkout re-reads the plan itself, and the backend re-reads it again before
 * charging anything, so a stale or tampered value can only ever be ignored.
 */
const KEY = "luxmart:installment-selection";

export interface StoredInstallmentSelection {
  bankId: number;
  termId: number;
}

export const readInstallmentSelection =
  (): StoredInstallmentSelection | null => {
    try {
      const raw = sessionStorage.getItem(KEY);
      if (!raw) return null;

      const parsed = JSON.parse(raw);
      if (
        typeof parsed?.bankId !== "number" ||
        typeof parsed?.termId !== "number"
      )
        return null;

      return parsed;
    } catch {
      // Private browsing and blocked site data both throw here; the checkout
      // simply starts without a plan chosen.
      return null;
    }
  };

export const writeInstallmentSelection = (
  selection: StoredInstallmentSelection | null,
) => {
  try {
    if (selection) {
      sessionStorage.setItem(KEY, JSON.stringify(selection));
    } else {
      sessionStorage.removeItem(KEY);
    }
  } catch {
    // Not being able to remember the choice is not worth failing over: the
    // checkout will just ask for it again.
  }
};
